export default __webpack_public_path__ + "static/Reliance-Trends-Logo-Vector-2e05b6d5c637cc2f5d7fb9b38b947f78.png";